import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class DepartmentsServices {
  constructor(private http: HttpClient) { }
  prefix: string = 'api/admin/departments';

    getDepartments(){
        let url = `${environment.host_url}/${this.prefix}/get_all_departments`;
        return this.http.get<any>(url).pipe(map(response => {
            return response;
        }))
    }

    getAllDocs(){
        let url = `${environment.host_url}/${this.prefix}/get_all_docs`;
        return this.http.get<any>(url).pipe(map(response => {
            return response;
        }))
    }

    saveDocs(data){
        let url = `${environment.host_url}/${this.prefix}/save_doc`;
        return this.http.post<any>(url, data).pipe(map(response => {
            return response;
        }))
    }

    getFilesByDepartament(id){
        let url = `${environment.host_url}/${this.prefix}/get_files_by_department?id=${id}`;
        return this.http.get<any>(url).pipe(map(response => {
            return response;
        }));
    }

    public saveAndGeneratePdf(data){
        let url = `${environment.host_url}/api/admin/departments/generate_pdf_file`;
        return this.http.post<any>(url, data).pipe(map((result)=>{
          return result;
        }));
      } 
}